import React from "react";
import DateDescriptionTooltip from "./DateDescriptionTooltip";

const DateType = (props) => {
  let className = "form-group pt-6 pl-3";
  if (props.showInDocUpload) {
    className = "form-group pt-3";
  }
  if (props.viewOnly) {
    className += " view-only row d-flex";
  }
  return (
    <div className={className}>
      <label
        className={[
          props.viewOnly ? "col-md-4 col-sm-6" : "bold",
          props.field.fieldLabel.length > 12 && props.viewOnly
            ? "hide-text"
            : "",
        ].join(" ")}
        htmlFor={props.field.fieldId}
      >
        {props.field.fieldLabel}
        {props.field.fieldRequired && !props.viewOnly && "*"}
      </label>
      <div
        className={`${
          props.viewOnly ? "col-md-8" : "col-md-12"
        } col-sm-6 d-flex pl-0 pr-0`}
      >
        {props.viewOnly && !props.field.fieldValue ? (
          <input
            className={["form-control", props.viewOnly ? "clickable" : ""].join(
              " "
            )}
            name={props.field.fieldLabel}
            type="text"
            id={props.field.fieldId}
            value="-"
            onChange={props.fieldValueChangeHandler}
          />
        ) : (
          <input
            className={["form-control", props.viewOnly ? "clickable" : ""].join(
              " "
            )}
            name={props.field.fieldLabel}
            type="date"
            id={props.field.fieldId}
            value={
              props.viewOnly && !props.field.fieldValue
                ? "-"
                : props.field.fieldValue
            }
            onChange={props.fieldValueChangeHandler}
          />
        )}
        {props.viewOnly && props.description[0] ? (
          <DateDescriptionTooltip
            description={props.description}
            index={props.index}
          />
        ) : null}
      </div>
      {props.viewOnly ? null : (
        <label className="field-description pl-1">
          {props.field.fieldDescription}
        </label>
      )}
    </div>
  );
};

export default DateType;
